import { RootState } from '../index';

export const getCustomersPerformanceSortFilters = (state: RootState) => ({
  keyword: state.customersPerformance.keyword,
  currentPage: state.customersPerformance.currentPage,
  filter: state.customersPerformance.filter,
  sort: state.customersPerformance.sort,
});
